
<template>
  <div>
    <form class="form-horizontal">
      <div class="box-body">
        <div class="form-group">
          <label class="col-sm-3 col-md-3 col-lg-3 control-label">Ngày Bắt Đầu</label>
          <div class="col-sm-8 col-md-8 col-lg-8">
            <date-picker
              :config="options"
              :value="apartment_cleaning_service.start_time"
              v-model="apartment_cleaning_service.start_time"
            ></date-picker>
          </div>
        </div>
        <div class="form-group" v-show="false">
          <label class="col-sm-3 col-md-3 col-lg-3 control-label">Ngày Kết Thúc</label>
          <div class="col-sm-8 col-md-8 col-lg-8">
            <date-picker
              :config="options"
              :value="apartment_cleaning_service.end_time"
              v-model="apartment_cleaning_service.end_time"
            ></date-picker>
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 col-md-3 col-lg-3 control-label">Tình Trạng</label>
          <div class="col-sm-8 col-md-8 col-lg-8">
            <b-form-select
              :options="apartmentCleaingServiceStatusOptions"
              required
              v-model="apartment_cleaning_service.status"
              class="form-control"
            />
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 col-md-3 col-lg-3 control-label">Nhân Viên</label>
          <div class="col-sm-8 col-md-8 col-lg-8">
            <b-form-select
              :options="apartmentCleaingServiceUserOptions"
              required
              v-model="apartment_cleaning_service.user"
              class="form-control"
            />
          </div>
        </div>
        <!-- {{this.item.cleaning_status_id}} -->
        <!-- END - Add new field -->
      </div>
      <div class="box-footer">
        <button
          type="button"
          class="btn btn-labeled btn-danger"
          @click="onApartmentCleaningServiceCancel"
          style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
        >
          <span class="btn-label">
            <i class="fa fa-mail-reply"></i>
          </span>
          {{$t('common.back')}}
        </button>
        <button
          type="button"
          class="btn btn-labeled btn-success pull-right"
          @click="onApartmentCleaningServiceSubmit"
          style="margin-right: 5px;"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
          </span>
          {{$t('common.save')}}
        </button>
      </div>
    </form>

    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <router-view></router-view>
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";
import utils from '@/lib/utils';
import datePicker from "vue-bootstrap-datetimepicker";
import constantsData from "@/lib/constantsData";

export default {
  name: "ApartmentAdd",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      apartment_cleaning_service: {
        start_time: new Date(),
        end_time: new Date(),
        status: 1,
        user: null
      },
      apartmentCleaingServiceStatusOptions: constantsData.cleaningService,
      apartmentCleaingServiceUserOptions: [],
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        minDate: new Date(Date.now() - 8640000),
        maxDate: new Date(Date.now() + 86400000 * 30)
      }
    };
  },

  watch: {},
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_USER_LIST",
      "GET_APARTMENT_CLEANING_SERVICE_BY_ID"
    ]),
    ...mapActions("bookingModule", [
      "ADD_APARTMENT_CLEANING_SERVICE",
      "UPDATE_APARTMENT_CLEANING_SERVICE"
    ]),
    onApartmentCleaningServiceCancel: function() {
      this.$emit("closeModal");
    },
    callBackToList: function() {
      this.$router.push({
        name: "LeaseBackAvailableApartmentList",
        query: {
          checkin_datetime: this.item.checkin,
          checkout_datetime: this.item.checkout
        }
      });
    },
    onApartmentCleaningServiceSubmit: function(event) {
      let cleaning_status_id = this.item.cleaning_status_id;
      let data = {
        apartment: this.item.id,
        start_time: utils.formatSqlDate(this.apartment_cleaning_service.start_time, "DD-MM-YYYY", "YYYY-MM-DDThh:mm"),
        end_time: utils.formatSqlDate(this.apartment_cleaning_service.end_time, "DD-MM-YYYY", "YYYY-MM-DDThh:mm"),
        // start_time: this.apartment_cleaning_service.start_time,
        // end_time: this.apartment_cleaning_service.end_time,
        status: this.apartment_cleaning_service.status,
        user: this.apartment_cleaning_service.user
      };
      if (cleaning_status_id == 0) {
        this.ADD_APARTMENT_CLEANING_SERVICE(data)
          .then(
            function(res) {
              this.$emit("closeModal");
              this.$emit("returnCleaningStatus", data.apartment, data.status);
              this.$emit("returnCleaningId", data.apartment, res, data.status);
              //this.callBackToList();
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function() {
              this.ERROR_TOAST();
            }.bind(this)
          );
      } else {
        this.UPDATE_APARTMENT_CLEANING_SERVICE({
          id: cleaning_status_id,
          data: data
        })
          .then(
            function() {
              this.$emit("closeModal");
              this.$emit("returnCleaningStatus", data.apartment, data.status);
              this.SUCCESS_TOAST();
              //this.callBackToList();
            }.bind(this)
          )
          .catch(
            function() {
              this.ERROR_TOAST();
            }.bind(this)
          );
      }
    }
  },
  mounted() {
    const data = {
      params: {
        page: 1
      }
    };
    this.GET_USER_LIST(data).then(
      function(res) {
        let users = [
          {
            value: null,
            text: "---"
          }
        ];
        let data = res.data.results;
        data.forEach(u => {
          let user = {
            value: u.id,
            text: u.first_name + " " + u.last_name
          };
          users.push(user);
        });
        this.apartmentCleaingServiceUserOptions = users;
      }.bind(this)
    );
    if (this.item.cleaning_status_id != 0) {
      this.GET_APARTMENT_CLEANING_SERVICE_BY_ID({
        id: this.item.cleaning_status_id
      })
        .then(
          function(res) {
            this.apartment_cleaning_service.user = res.user;
            this.apartment_cleaning_service.status = res.status;
            this.apartment_cleaning_service.start_time = utils.formatSqlDate(res.start_time, "YYYY/MM/DD", "DD/MM/YYYY");
          }.bind(this)
        )
        .catch(function() {}.bind(this));
    }
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackApartmentCleaningService.vue